if ($('.c-article-preview__pic').length) {
    $('.c-article-preview__pic').on('click', function () {
        console.log('c');
        href = $(this).prev('.c-article-preview__title-link').attr('href');
        window.location.href = href;
    });
}

if ($('.c-featured-articles-preview__pic').length) {
    $('.c-featured-articles-preview__pic').on('click', function () {
        console.log('c');
        href = $(this).closest('.c-featured-articles-preview__content').find('.c-featured-articles-preview__title-link').attr('href');
        window.location.href = href;
    });
}